import {
  faLightbulb,
  faPlusCircle,
  faSearch,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import Loader from "react-loader-spinner";
import { useHistory } from "react-router-dom";

import { Modal } from "semantic-ui-react";
import Swal from "sweetalert2";
import authService from "../../services/authService";
import { useHttpClient } from "../../util/http-hook";
import AggiungiOpportunita from "../components/AggiungiOpportunita";
import ReactPaginate from "react-paginate";
import "../../App.css";

import OpportunitaList from "../components/OpportunitaList";

const PaginaOpportunita = () => {
  const { sendRequest, isLoading } = useHttpClient();
  const token = authService.getCurrentToken();
  const [open, setOpen] = useState(false);
  const [risultati, setRisultati] = useState();
  const history = useHistory();

  //Paginazione
  const [numeroPagine, setNumeroPagine] = useState(0);
  const [offset, setOffset] = useState(0);
  const [paginaSelezionata, setPaginaSelezionata] = useState(0);
  const [debouncedRicerca, setDebouncedRicerca] = useState("");
  const [refresh, setRefresh] = useState(0);
  const elementiPerPagina = 50;

  const handlePageChange = (e) => {
    const selectedPage = e.selected;
    const offset = selectedPage * elementiPerPagina;

    setPaginaSelezionata(selectedPage);
    setOffset(offset);
  };

  //Fine paginazione

  const formik = useFormik({
    initialValues: {
      ricerca: "",
    },
  });

  useEffect(() => {
    const checkValido = async function () {
      const email = authService.getCurrentEmail();
      try {
        const responseData = await sendRequest(
          process.env.REACT_APP_BASE_URL + `/utenti/controllaValido/${email}`,
          "GET",
          null
        );
        if (!responseData) {
          Swal.fire({
            icon: "error",
            title: "Qualcosa è andato storto...",
            text:
              "Problemi con i dati, provare a effettuare nuovamente il login.",
          }).then(() => {
            authService.logout();
            history.go(0);
          });
        }
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Qualcosa è andato storto...",
          text: error,
        }).then(() => authService.logout());
      }
    };
    if (token) {
      checkValido();
    }
  }, [token, sendRequest, history]);

  // Debounce della ricerca: aspetta che l'utente smetta di digitare
  // e riparte dalla prima pagina (la ricerca viene fatta lato server).
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedRicerca(formik.values.ricerca);
      setPaginaSelezionata(0);
      setOffset(0);
    }, 400);
    return () => clearTimeout(handler);
  }, [formik.values.ricerca]);

  const aggiungiOpportunita = () => {
    // Ricarica la pagina corrente dal server dopo l'inserimento.
    setRefresh((r) => r + 1);
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    // Evita che la risposta di una richiesta precedente (es. la fetch
    // iniziale senza ricerca) sovrascriva i risultati di quella corrente.
    let ignora = false;

    const ottieniOpportunita = async () => {
      const ruolo = authService.getCurrentRuolo();
      const endpoint =
        ruolo === "collaboratore"
          ? "/opportunita/collaboratore"
          : "/opportunita/";

      const params = new URLSearchParams({
        limit: elementiPerPagina,
        offset,
        search: debouncedRicerca,
      });

      try {
        const responseData = await sendRequest(
          process.env.REACT_APP_BASE_URL +
            endpoint +
            "?" +
            params.toString(),
          "GET",
          null,
          {
            Authorization: "Bearer " + token,
          }
        );
        if (ignora) return;
        setRisultati(responseData.opportunita);
        setNumeroPagine(Math.ceil(responseData.totale / elementiPerPagina));
      } catch (err) {
        if (ignora) return;
        Swal.fire({
          icon: "error",
          title: "Qualcosa è andato storto...",
          text: err,
        });
      }
    };

    const ruolo = authService.getCurrentRuolo();
    if (token && (ruolo === "amministratore" || ruolo === "collaboratore")) {
      ottieniOpportunita();
    }

    return () => {
      ignora = true;
    };
  }, [sendRequest, token, offset, debouncedRicerca, refresh]);

  return (
    <React.Fragment>
      <Modal
        onClose={() => setOpen(false)}
        onOpen={() => setOpen(true)}
        open={open}
        style={{ position: "relative", height: "auto" }}
      >
        <Modal.Header className="text-center">
          Aggiungi nuova opportunità <FontAwesomeIcon icon={faLightbulb} />{" "}
        </Modal.Header>
        <Modal.Content scrolling>
          <Modal.Description>
            <AggiungiOpportunita
              handleClose={handleClose}
              aggiungiOpportunita={aggiungiOpportunita}
            />
          </Modal.Description>
        </Modal.Content>
      </Modal>
      <div className="card my-2 mx-3" style={{ borderRadius: "10px" }}>
        <div
          className="card-header border-0"
          style={{ borderTopRightRadius: "10px", borderTopLeftRadius: "10px" }}
        >
          <h3 className="mb-0 text-center">Opportunità</h3>
        </div>

        <div className="card-body">
          <label
            className="float-left align-middle mt-2 col-md-6 col-lg-6 col-sm-12  p-0"
            style={{ fontWeight: 500 }}
            role="button"
            onClick={() => setOpen(true)}
          >
            <FontAwesomeIcon icon={faPlusCircle} className="mr-2" />
            Aggiungi opportunità
          </label>
          <form onSubmit={(e) => e.preventDefault()}>
            <div className="form-group row col-md-6 col-lg-6 col-sm-12 ">
              <label
                htmlFor="ricerca"
                className="col-sm-12 col-md-3 col-lg-3 mt-2 p-0 text-lg-right mr-1"
              >
                <FontAwesomeIcon
                  icon={faSearch}
                  className="mr-1  p-0"
                ></FontAwesomeIcon>
                Ricerca
              </label>
              <div className="col-sm-8 ml-auto p-0">
                <input
                  id="ricerca"
                  className="form-control text-center"
                  name="ricerca"
                  type="text"
                  onChange={formik.handleChange}
                  value={formik.values.ricerca}
                  style={{ borderRadius: "500rem" }}
                />
              </div>
            </div>
          </form>
        </div>
      </div>
      <Loader
        type="ThreeDots"
        color="#385898"
        height={80}
        width={80}
        visible={isLoading}
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
        }}
      />
      <ReactPaginate
        previousLabel={"<"}
        nextLabel={">"}
        breakLabel={"..."}
        breakClassName={"break-me"}
        pageCount={numeroPagine}
        forcePage={paginaSelezionata}
        marginPagesDisplayed={1}
        pageRangeDisplayed={2}
        onPageChange={handlePageChange}
        containerClassName={"pagination"}
        subContainerClassName={"pages pagination"}
        activeClassName={"active"}
      />
      {!isLoading && risultati && <OpportunitaList items={risultati} />}
    </React.Fragment>
  );
};

export default PaginaOpportunita;
